module.exports = __webpack_public_path__ + "stu-res/img/course-2.333af77d.png";